export interface INormalizedObjects<T> {
    allIds: string[];
    byId: { [id: string]: T };
}

export const initialNormalizedObjects: INormalizedObjects<any> = {
    allIds: [],
    byId: {}
}